module.exports = __webpack_public_path__ + "media/images/flags/eh-6f0e07d1d6bddc4d00cd9d0f8e22bea1.svg";